import { a3Copy } from "@/components/assignments/a3-copy";
import { createContext, useContext } from "react";
import { formatWhen } from "@/lib/assignment-presentation";
import { formatInCourseZone } from "@/lib/session-portal";
import type { Submission } from "@/lib/api/assignments";
import { admittedWords } from "@/components/session/handin/hand-in-model";

export const AssignmentTimezone = createContext<string | null>(null);

export function useAssignmentDate() {
  const timezone = useContext(AssignmentTimezone);
  return (value: string | null | undefined, fallback: string = a3Copy.notSet2) => value && timezone
    ? formatInCourseZone(value, timezone, { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit", timeZoneName: "short" })
    : formatWhen(value ?? null, fallback);
}

export function assignmentNumber(value: number | string | null | undefined, fallback: string = a3Copy.notSet2) {
  return value == null ? fallback : Number(value).toLocaleString("en-US", { maximumFractionDigits: 2 });
}

/** The receipt's words for a hand-in: when it arrived and the deadline it was admitted under. */
export function useAdmittedWords() {
  const timezone = useContext(AssignmentTimezone) ?? "UTC";
  return (receipt: Submission) => admittedWords(receipt, timezone);
}

export function useAssignmentTime() {
  const timezone = useContext(AssignmentTimezone);
  return (value: string) => timezone
    ? formatInCourseZone(value, timezone, { hour: "numeric", minute: "2-digit", timeZoneName: "short" })
    : new Intl.DateTimeFormat("en-US", { hour: "numeric", minute: "2-digit" }).format(new Date(value));
}
